class t{constructor(t,s,e,i){this.kind=t,this.name=s,this.val=e,this.scope=i}get value(){return this.val}set(t){this.val=t}}export{t as Var};
